__webpack_require__.p = "/MrBrownPortfolio/";